import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
const useStyles = makeStyles(({
  typography
}) => ({
  text: {
    fontSize: typography.pxToRem(15),
    letterSpacing: 0.3,
    fontWeight: 300
  },
  title: {
    marginRight: typography.pxToRem(10),
    color: "#1d9ad0"
  },
  row: {
    marginBottom: typography.pxToRem(5)
  },
  cell: {
    marginBottom: typography.pxToRem(30)
  },
  value: {
    fontWeight: "normal"
  }
}));

const MobileTable = ({
  rows
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Grid, null, rows.map((row, i) => /*#__PURE__*/React.createElement(Grid, {
    className: styles.cell,
    key: i
  }, row.map(el => {
    return el.value && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      className: styles.row,
      key: Math.random()
    }, el.title && /*#__PURE__*/React.createElement(Typography, {
      className: clsx(styles.text, styles.title)
    }, el.title), /*#__PURE__*/React.createElement(Typography, {
      className: clsx(styles.text, styles.value)
    }, el.value));
  }))));
};

export default MobileTable;